<template>
  <span>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      class="tw-fill-current"
    >
      <path
        d="M15.75 3.3749V6.7499C15.75 6.89908 15.6907 7.04216 15.5852 7.14765C15.4798 7.25314 15.3367 7.3124 15.1875 7.3124H11.8125C11.6633 7.3124 11.5202 7.25314 11.4148 7.14765C11.3093 7.04216 11.25 6.89908 11.25 6.7499C11.25 6.60071 11.3093 6.45764 11.4148 6.35215C11.5202 6.24666 11.6633 6.1874 11.8125 6.1874H13.8298L12.8011 5.15873C11.7557 4.10854 10.3363 3.51605 8.85445 3.51131H8.82281C7.3534 3.50786 5.9417 4.083 4.89305 5.11232C4.78562 5.2126 4.64322 5.26686 4.4963 5.26349C4.34939 5.26012 4.20962 5.19939 4.10691 5.09429C4.0042 4.98919 3.9467 4.84806 3.9467 4.70111C3.94671 4.55415 4.00423 4.41304 4.10695 4.30795C5.37787 3.0658 7.08737 2.37497 8.86446 2.38537C10.6415 2.39577 12.3428 3.10656 13.5991 4.36349L14.625 5.39216V3.3749C14.625 3.22571 14.6843 3.08264 14.7898 2.97715C14.8952 2.87166 15.0383 2.8124 15.1875 2.8124C15.3367 2.8124 15.4798 2.87166 15.5852 2.97715C15.6907 3.08264 15.75 3.22571 15.75 3.3749ZM13.107 12.8875C12.0479 13.9219 10.6238 14.4972 9.1434 14.4885C7.663 14.4798 6.24571 13.8879 5.19891 12.8411L4.17023 11.8124H6.1875C6.33668 11.8124 6.47976 11.7531 6.58525 11.6476C6.69074 11.5422 6.75 11.3991 6.75 11.2499C6.75 11.1007 6.69074 10.9576 6.58525 10.8522C6.47976 10.7467 6.33668 10.6874 6.1875 10.6874H2.8125C2.66332 10.6874 2.52024 10.7467 2.41475 10.8522C2.30926 10.9576 2.25 11.1007 2.25 11.2499V14.6249C2.25 14.7741 2.30926 14.9172 2.41475 15.0226C2.52024 15.1281 2.66332 15.1874 2.8125 15.1874C2.96168 15.1874 3.10476 15.1281 3.21025 15.0226C3.31574 14.9172 3.375 14.7741 3.375 14.6249V12.6076L4.40367 13.6363C5.6582 14.8971 7.362 15.6083 9.14062 15.6135H9.17789C10.9414 15.618 12.6357 14.9276 13.8938 13.6919C13.9965 13.5868 14.054 13.4456 14.054 13.2987C14.054 13.1517 13.9965 13.0106 13.8938 12.9055C13.7911 12.8004 13.6513 12.7397 13.5044 12.7363C13.3575 12.7329 13.2151 12.7872 13.1077 12.8875H13.107Z"
        :fill="fillColor ? fillColor : 'currentColor'"
      />
    </svg>
  </span>
</template>
<script>
export default {
  name: 'ArrowsClockwise',
  props: {
    fillColor: {
      type: String,
      default: null,
    },
  },
};
</script>
